import React from 'react';
import { ArrowRight, DollarSign, ArrowDownUp, Coins, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const CexBuyPage = () => {
  return (
    <div className="bg-gradient-to-r from-sky-50 via-sky-50/80 to-white min-h-screen">
      <div className="max-w-4xl mx-auto px-4 pt-6 pb-8 md:py-16">
        {/* Back Button */}
        <Link
          to="/buy"
          className="inline-flex items-center gap-2 text-sky-500 hover:text-sky-600 transition-colors mb-8 md:mb-12"
        >
          <ArrowLeft className="w-5 h-5" />
          <span className="font-medium">Back to options</span>
        </Link>

        <div className="text-center mb-8 md:mb-12">
          <h1 className="text-3xl md:text-4xl font-bold text-sky-500 mb-2 md:mb-4">How to Buy $BOOP on CoinEx</h1>
          <p className="text-gray-600 text-base md:text-lg">Follow these simple steps to purchase BOOP tokens on CoinEx Exchange</p>
        </div>

        <div className="space-y-6 md:space-y-8">
          {/* Step 1 */}
          <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 md:p-6 hover:bg-white border border-sky-200 hover:border-sky-300 transition-all shadow-sm">
            <div className="flex flex-col md:flex-row items-start gap-4">
              <div className="bg-sky-50 rounded-lg p-3">
                <DollarSign className="w-6 h-6 text-sky-500" />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-sky-500 mb-2">1. Create a CoinEx Account</h3>
                <p className="text-gray-600 mb-4">Register and complete verification on CoinEx:</p>
                <a
                  href="https://www.coinex.com/register"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-sky-500 hover:bg-sky-600 text-white rounded-lg px-4 py-2 font-medium transition-colors inline-flex items-center gap-2 text-sm md:text-base"
                >
                  Register on CoinEx
                  <ArrowRight className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 md:p-6 hover:bg-white border border-sky-200 hover:border-sky-300 transition-all shadow-sm">
            <div className="flex flex-col md:flex-row items-start gap-4">
              <div className="bg-sky-50 rounded-lg p-3">
                <ArrowDownUp className="w-6 h-6 text-sky-500" />
              </div>
              <div className="w-full">
                <h3 className="text-xl font-semibold text-sky-500 mb-2">2. Deposit Funds</h3>
                <p className="text-gray-600 mb-4">Choose your preferred deposit method:</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
                  <div className="bg-white/50 rounded-lg p-4 border border-sky-200">
                    <h4 className="font-medium text-sky-500">Crypto Deposit</h4>
                    <p className="text-sm text-gray-600 mt-1">Deposit USDT, BTC, or other supported cryptocurrencies</p>
                  </div>
                  <div className="bg-white/50 rounded-lg p-4 border border-sky-200">
                    <h4 className="font-medium text-sky-500">Card Payment</h4>
                    <p className="text-sm text-gray-600 mt-1">Buy crypto directly with your credit/debit card</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="bg-white/80 backdrop-blur-sm rounded-xl p-4 md:p-6 hover:bg-white border border-sky-200 hover:border-sky-300 transition-all shadow-sm">
            <div className="flex flex-col md:flex-row items-start gap-4">
              <div className="bg-sky-50 rounded-lg p-3">
                <Coins className="w-6 h-6 text-sky-500" />
              </div>
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-sky-500 mb-2">3. Buy BOOP</h3>
                <p className="text-gray-600 mb-4">Trade BOOP on CoinEx spot market:</p>
                <div className="space-y-4">
                  <a
                    href="YOUR_COINEX_BOOP_USDT_PAIR"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-white/50 hover:bg-white text-sky-500 rounded-lg p-4 flex items-center justify-between group border border-sky-200 hover:border-sky-300"
                  >
                    <div>
                      <span className="font-medium">BOOP/USDT</span>
                      <p className="text-sm text-gray-600 mt-1">Trade with USDT pair</p>
                    </div>
                    <ArrowRight className="w-5 h-5 text-sky-400 group-hover:text-sky-500 transform group-hover:translate-x-1 transition-all" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Withdrawal Info */}
          <div className="bg-sky-50/80 backdrop-blur-sm rounded-xl p-4 md:p-6 mt-6 md:mt-8 border border-sky-200">
            <h3 className="text-lg font-semibold text-sky-500 mb-2">After Purchase</h3>
            <p className="text-gray-600 text-sm md:text-base">
              Consider withdrawing your BOOP tokens to your personal wallet for better security.
              You can withdraw to either:
            </p>
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
              <div className="bg-white/80 rounded-lg p-4 border border-sky-200">
                <h4 className="font-medium text-sky-500">Arbitrum Network</h4>
                <p className="text-sm text-gray-600 mt-1">Withdraw to your Arbitrum wallet (e.g., MetaMask)</p>
              </div>
              <div className="bg-white/80 rounded-lg p-4 border border-sky-200">
                <h4 className="font-medium text-sky-500">Solana Network</h4>
                <p className="text-sm text-gray-600 mt-1">Withdraw to your Solana wallet (e.g., Phantom)</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CexBuyPage;